import * as React from "react"
import { Popover as BasePopover } from "@base-ui/react/popover"
import { cn } from "@lib/cn"

const Root = BasePopover.Root
const Trigger = BasePopover.Trigger
const Portal = BasePopover.Portal
const Close = BasePopover.Close

const Content = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof BasePopover.Popup> & {
    side?: "top" | "right" | "bottom" | "left"
    align?: "start" | "center" | "end"
    sideOffset?: number
  }
>(({ className, side = "bottom", align = "start", sideOffset = 6, children, ...props }, ref) => (
  <BasePopover.Portal>
    <BasePopover.Positioner side={side} align={align} sideOffset={sideOffset} className="z-50">
      <BasePopover.Popup
        ref={ref}
        className={cn(
          "min-w-[14rem] rounded-md border p-3 outline-none",
          "bg-white text-cloverhound-gray-900 dark:bg-cloverhound-gray-900 dark:text-cloverhound-gray-50",
          "border-cloverhound-gray-250 dark:border-cloverhound-gray-800",
          "shadow-lg",
          "data-[starting-style]:opacity-0 data-[starting-style]:scale-95",
          "data-[ending-style]:opacity-0 data-[ending-style]:scale-95",
          "transition-all duration-quick ease-out-quad",
          className,
        )}
        {...props}
      >
        {children}
      </BasePopover.Popup>
    </BasePopover.Positioner>
  </BasePopover.Portal>
))
Content.displayName = "Popover.Content"

export const Popover = { Root, Trigger, Portal, Content, Close }
